import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 17.416 18.999",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.416 18.999\" id=\"icon-close\">\r\n  <defs>\r\n    <style>\r\n      #icon-close .cls-1 {\r\n        fill: #8f9daf;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-close_双右箭头\" class=\"cls-1\" d=\"M171.083,147h-3.167l6.333-9.436L167.916,128h3.167l6.333,9.365Zm-7.916,0H160l6.333-9.436L160,128h3.167l6.333,9.365Z\" transform=\"translate(-160 -128)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol